/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CampaignSendTimeDto { 
    /**
     * ISO weekday of delivery in X-APP-TIMEZONE: 1 Monday through 7 Sunday.
     */
    weekday: number;
    slot: CampaignSendTimeDto.SlotEnum;
    /**
     * Deliveries in this local-time slot. Only 08:00 to before 23:00 is covered by the grid.
     */
    sent: number;
    /**
     * Distinct customer/campaign pairs whose period clicks match their latest preceding delivery in this slot. No maximum click-to-delivery delay; both click and selected delivery must be in the requested period.
     */
    uniqueClicks: number;
    /**
     * Slot uniqueClicks / sent; fraction, 0 without deliveries. Observational, without minimum sample size or control for audience/content; not proof of the best send time.
     */
    ctr: number;
}
export namespace CampaignSendTimeDto {
    export const SlotEnum = {
        _0811: '08-11',
        _1114: '11-14',
        _1417: '14-17',
        _1720: '17-20',
        _2023: '20-23'
    } as const;
    export type SlotEnum = typeof SlotEnum[keyof typeof SlotEnum];
}


